// extracted by mini-css-extract-plugin
export default {"text":"TicketSalesStatusSummary-rebranding-module__text___2CzCy"};